export default "__VITE_ASSET__DqEjalC$__"